import LabradorBanner, { StandaloneBanner, StandaloneBannerProps } from '@/base/components/content/Banner';
import { StandaloneComponent } from '@/types/component';
import mergeProps from '@/utils/mergeProps';

const AllasStandaloneBanner: StandaloneComponent<StandaloneBannerProps> = (props) => {
  return <StandaloneBanner {...mergeProps({ link: { href: '/korsord-och-spel' } }, props)} />;
};

export const standalone = AllasStandaloneBanner;

export default LabradorBanner;
